export const MassivhausIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1.66666in'
      height='1.66666in'
      version='1.1'
      fillRule='evenodd'
      clipRule='evenodd'
      textRendering='geometricPrecision'
      imageRendering='optimizeQuality'
      shapeRendering='geometricPrecision'
      viewBox='0 0 1666.66 1666.66'>
      <g id='Layer_x0020_1'>
        <metadata id='CorelCorpID_0Corel-Layer' />
        <g id='_2559305326304'>
          <rect fill='#B3B3B3' x='-0' y='0' width='1666.66' height='1666.66' />
          <g>
            <polygon
              fill='white'
              fillRule='nonzero'
              points='721.19,1327.72 720.49,1036.24 577.53,1276.37 526.87,1276.37 384.6,1042.49 384.6,1327.72 279.11,1327.72 279.11,841.92 372.11,841.92 553.93,1143.81 732.98,841.92 825.28,841.92 826.67,1327.72 '
            />
            <path
              fill='white'
              d='M833.33 338.94l441.8 255.07 0 -104.97 112.43 0 0 169.88 112.43 64.91 0 129.81 -666.65 -384.9 -666.65 384.9 0 -129.81 666.65 -384.89zm554.23 514.7c0,157.84 -0.12,316.07 -0.12,474.07l-112.43 0 0 -199.18 -220.69 0 0 199.18 -112.43 0 0 -485.81 112.43 0 0 191.55 220.69 0c0,-81.65 0.12,-163.18 0.12,-244.72 37.47,21.63 75.07,43.12 112.43,64.91z'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
